import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';

const CartAffirm = (props) => {
  const [currentTotalPrice, setcurrentTotalPrice] = 
    useState( parseFloat(props.totalPrice) );
  const affirmThreshold = 
    props.affirmThreshold ? props.affirmThreshold * 100 : 0;

  useEffect(() => window.affirm?.ui.refresh && window.affirm.ui.refresh(), 
    [currentTotalPrice]); 

  useEffect(() => {
    setcurrentTotalPrice( parseFloat(props.totalPrice) );
  }, [props]);

  return (
    <div>
      {(currentTotalPrice > affirmThreshold) &&
      <div className="minicart-affirm-container">
        <p
            className="affirm-as-low-as"
            data-amount={currentTotalPrice}
            data-affirm-type="logo"
            data-page-type="product"
            data-affirm-color="blue"
            style="font-size: 11px; color: #404040; text-align: center;">
        </p>
      </div>}
    </div>
  )
}

export default CartAffirm;